import { cipo } from 'cipo';
import { FormattingType, FormattingTypeValues, FormattingValueType, RestrictionType, RestrictionValueType } from 'src/app/models/module/fields/enums';
import { DisplayFormats } from 'src/app/shared/components/data-list/common';
import moment from 'moment';

cipo.factory("ProgressPaymentSA", function (CommonEntityInstance, Form, WorkflowScreen, AdjustmentItem, $q, $location, Message, Dictionaries, URI, userService, currencyService, $timeout, PdfHandler) {
    const EDIT_PERCENTAGE = 1;
    const EDIT_AMOUNT = 2;
    const EDIT_QUANTITY = 3;
    const MODULE_PROGRESS_PAYMENT = -3;
    const MODULE_SOVI = -5;
    const MODULE_ADJUSTMENTS = -30;

    var ProgressPaymentSA = CommonEntityInstance.extend(function (module, entityInstanceId, types, selectedPeriodId, isNoDetails, screenId, sovEntityInstanceId) {
        var self = this;
        self.properties = { entityInstanceId: entityInstanceId || 0 };
        self.startScreens = [];
        self.entityInstanceId = entityInstanceId || 0;
        self.contractId = userService.system.userdata.contractId || 0;
        self.userService = userService;
        self.moduleId = module.moduleId;
        self.module = module;
        self.moduleCode = 'PP';
        self.selectedPeriodId = selectedPeriodId || 0;
        self.sovEntityInstanceId = sovEntityInstanceId;
        self.isBusy = true;
        self.editType = EDIT_PERCENTAGE;
        self.hasPaymentQuantityFields = false;
        self.hasPaymentPercentageFields = false;
        self.hasPaymentAmountFields = false;
        self.paymentTypes = [];
        self.isBusyTransitions = true;
        self.isAllPayments = false;
        self.editMode = false;
        self.lookup = {};
        self.moduleName = userService.system.modules[self.moduleCode]?.name || "PP";
        self.types = types || [];
        self.pageSize = 20;
        self.showPP = true;
        self.screenId = screenId || 0;
        self.otherDraftsColumns = [
            { id: 1, name: "userName", displayName: "User", sortable: true },
            { id: 2, displayFormatId: DisplayFormats.Status, name: "state_name", displayName: "Status", sortable: true },
            { id: 3, displayFormatId: DisplayFormats.Date, name: "createdOn", displayName: "Created On", sortable: true, restrictions: [{ key: RestrictionType.DateTime, value: RestrictionValueType.DateTime }] }
        ];

        self.isLoaded = false;
        self.propertiesScreen = new WorkflowScreen({
            moduleId: self.moduleId,
            entityInstanceId: self.entityInstanceId,
            contractId: self.contractId,
            isStartScreen: true,
            isDraftState: !self.entityInstanceId,
            screenId: self.screenId
        });

        self.wbs = [];

        // payment quantity fields: -65/payment_qty, -66/previous_payment_qty, -67/paid_qty
        self.quantityFieldsId = [-65, -66, -67];
        // payment percentage fields: -28/payment_percentage, -30/previous_payment_percentage, -32/paid_percentage
        self.percentageFieldsId = [-28, -30, -32];
        // payment amount fields: -27/payment_amount, -29/previous_payment_amount, -31/paid_amount
        self.amountFieldsId = [-27, -29, -31];

        self.getStartScreens()
            .then(function () {
                self.initGeneralInfo(isNoDetails);
            })
            .catch(function () {
                self.initGeneralInfo(isNoDetails);
            });

        currencyService.getAndSetCurrencyById(self);
            
        //self.get_Data();
        self.itemsLookup = {};
        self.ppiLookup = {};
        self.isModulesLoaded = false;
        self.modulesLookup = {};
        self.modulesList = [];

        self.pdfHandler = new PdfHandler({
            moduleId: self.moduleId,
            moduleName: self.module.name,
            moduleCode: self.moduleCode,
            contractId: self.contractId,
            contractNo: userService.system.context.contract?.no,
            onEmailSent: function () {
                this.get_activity_summary();
            },
        });

        Object.defineProperty(self, 'isEditablePercentage', {
            get: function () {
                return this.editType == EDIT_PERCENTAGE;
            }
        });
        Object.defineProperty(self, 'isEditableAmount', {
            get: function () {
                return this.editType == EDIT_AMOUNT;
            }
        });
        Object.defineProperty(self, 'isEditableQuantity', {
            get: function () {
                return this.editType == EDIT_QUANTITY;
            }
        });

        Object.defineProperty(self, 'isEditQuantityAvailable', {
            get: function () {
                return this.hasPaymentQuantityFields && this.paymentTypes.some(pt => pt.key == EDIT_QUANTITY);
            }
        });
        Object.defineProperty(self, 'isEditPercentageAvailable', {
            get: function () {
                return this.hasPaymentPercentageFields && this.paymentTypes.some(pt => pt.key == EDIT_PERCENTAGE);
            }
        });
        Object.defineProperty(self, 'isEditAmountAvailable', {
            get: function () {
                return this.hasPaymentAmountFields && this.paymentTypes.some(pt => pt.key == EDIT_AMOUNT);
            }
        });
    });

    ProgressPaymentSA.prototype.goToProgressPayment = function() {
        var self = this;
        var tId = userService.getTenantIdentifierById(userService.tenantId);
        var cId = self.contractId;
        var pId = self.selectedPeriodId || 0;
        var eIId = self.entityInstanceId || 0;
        $location.url(`${tId}/progresspayment/${cId}/${pId}/${eIId}`);
    }

    ProgressPaymentSA.prototype.initGeneralInfo = function (isNoDetails) {
        var self = this;
        if (self.types.length && !isNoDetails) { self.get_general_info(null, false); }
        else if (!self.types.length) {
            Dictionaries.ModuleTypes(-3)
                .then(function (r) {
                    self.types = r || [];
                    if (self.types.length) self.get_general_info(null, false);
                    else Message.error("No module types");
                })
                .catch(function () { })
        }
    }

    ProgressPaymentSA.prototype.setEditTypePercentage = function () {
        this.editType = EDIT_PERCENTAGE;
        this.showHideColumns();
    }
    ProgressPaymentSA.prototype.setEditTypeAmount = function () {
        this.editType = EDIT_AMOUNT;
        this.showHideColumns();
    }
    ProgressPaymentSA.prototype.setEditTypeQuantity = function () {
        this.editType = EDIT_QUANTITY;
        this.showHideColumns();
    }
    ProgressPaymentSA.prototype.setEditType = function (typeId) {
        var self = this;
        switch(typeId) {
            case EDIT_AMOUNT:
                self.setEditTypeAmount();
                break;

            case EDIT_QUANTITY:
                self.setEditTypeQuantity();
                break;

            default:
                self.setEditTypePercentage();
                break;
        }
    }

    ProgressPaymentSA.prototype.showHideColumns = function () {
        var moduleSovi = this.modulesList.find(m => m.moduleId == MODULE_SOVI);
        if (!moduleSovi) {
            return;
        }
    }

    ProgressPaymentSA.prototype.setupApprovalForm = function () {
        var self = this;
        self.approvalContent = {
            comment: ""
        }
        self.approvalForm = new Form(self.approvalContent);
        // self.approvalForm.initializing = true;
        self.approvalForm.set_Description(
            { comment: { label: 'Comment', type: 'editor' } });
    }

    ProgressPaymentSA.prototype.cancelApprove = function () {
        var self = this;
        var p = $q.defer();
        self.isBusy = true;
        var urlParams = {
            approvalId: self.generalInfo.approvalId,
            contractId: userService.system.userdata.contractId,
        };
        self[URI.MODULE_APPROVAL.CANCEL_APPROVAL.method](URI.MODULE_APPROVAL.CANCEL_APPROVAL, { url: urlParams, urltype: 'obj' })
            .then(function (result) {
                self.get_general_info();
                self.get_activity_summary();
                self.isModified = true;
                p.resolve();
            })
            .catch(function (e) {
                p.reject(e);
            })
            .finally(function () {
                self.isBusy = false;
            });

        return p.promise;
    }

    ProgressPaymentSA.prototype.approve = function (isApprove) {
        var self = this;
        var p = $q.defer();
        self.isBusy = true;
        var urlParams = {
            // approvalId: self.data.approvalId,
            contractId: userService.system.userdata.contractId,
            moduleId: self.moduleId
        }
        var bodyParams = {
            id: self.generalInfo.approvalId,
            approved: isApprove ? true : false,
            comment: self.approvalContent.comment,
            // documentNumber: self.selectedDocNo ? self.selectedDocNo.key : null
        };
        self.approvalForm.loading = true;
        var dataURL = URI.PROGRESS_PAYMENT.PP_DO_APPROVAL;
        self[dataURL.method](dataURL, { url: urlParams, urltype: 'obj', body: bodyParams })
            .then(function (result) {
                self.get_general_info();

                self.isModified = true;

                p.resolve();
            })
            .catch(function (e) {
                p.reject(e);
                Message.dberror(e);
                self.approvalForm.loading = false;
                // self.form.catch(e);
            })
            .finally(function () {
                self.isBusy = false;
            })

        return p.promise;
    }

    ProgressPaymentSA.prototype.comment = function () {
        var self = this;
        var p = $q.defer();


        if (self.approvalContent.comment) {
            self.isBusy = true;
            var urlParams = {
                // approvalId: self.data.approvalId,
                contractId: userService.system.userdata.contractId,
            }
            var bodyParams = {
                entityInstanceId: self.entityInstanceId,
                comment: self.approvalContent.comment
            };
            self.approvalForm.loading = true;
            self[URI.MODULE_APPROVAL.ADD_COMMENT.method](URI.MODULE_APPROVAL.ADD_COMMENT, { url: urlParams, urltype: 'obj', body: bodyParams })
                .then(function (result) {
                    self.get_activity_summary();
                    self.approvalContent.comment = "";
                    self.isModified = true;

                    p.resolve();
                })
                .catch(function (e) {
                    p.reject(e);
                    Message.dberror(e);

                })
                .finally(function () {
                    self.isBusy = false;
                    self.approvalForm.loading = false;
                })
        }
        else {
            Message.error("Please add comment");
            p.reject();
        }

        return p.promise;
    }

    ProgressPaymentSA.prototype.save = function (transitionId, roleId, isRevise, emails, roleToExcludeIds) {
        var self = this;
        var p = $q.defer();
        var dataURL = URI.PROGRESS_PAYMENT.PP_SAVE;
        if (isRevise) dataURL = URI.PROGRESS_PAYMENT.PP_REVISE;
        var saveParams = {
            contractId: self.contractId,
            roleId: roleId,
            entityInstanceId: self.entityInstanceId,
            paymentPeriodId: self.selectedPeriodId,
            moduleTypeId: (self.currentType || {}).key || self.types[0].key,
            workflowId: userService.getWorkflowId(self.moduleId),
            sovEntityInstanceId: self.sovEntityInstanceId
        };
        var body = { 
            emails: (emails ?? []).filter((e) => !Number(e)),
            groups: (emails ?? []).filter((e) => Number(e)),
            roleToExcludeIds: roleToExcludeIds ?? [],
            screenId: self.generalInfo.screenId || self.screenId,
            values: self.propertiesScreen.valuesDictionary || [],
        }
        saveParams.transitionId = transitionId;
        self.isBusy = true;
        self[dataURL.method](dataURL, { url: saveParams, urltype: 'obj', body: body })
            .then(function (r) {
                if (r) self.entityInstanceId = r;
                self.isBusy = false;
                p.resolve(r);
            })
            .catch(function (e) {
                console.error(e);
                Message.dberror(e);
                self.isBusy = false;
                p.reject(e)
            })

        return p.promise;
    }

    ProgressPaymentSA.prototype.get_general_info = function (id, loadActivity = true) {
        var self = this;
        var p = $q.defer();
        self.isBusy = true;
        var dataURL = URI.PROGRESS_PAYMENT.GET_GENERAL_INFO;

        self.itemsLookup = {};
        self.ppiLookup = {};
        self.isModulesLoaded = false;
        self.modulesLookup = {};
        self.modulesList = [];

        self.generalInfo = {};
        self.workflow = {
            transitions: [],
            transitionsInstancesList: [],
            pastAssignments: []
        };
        self.signInfo = {};

        var params = {
            moduleId: MODULE_PROGRESS_PAYMENT,
            contractId: self.contractId,
            // transitionId: transitionId || 0,
            entityInstanceId: id || self.entityInstanceId || 0,
            paymentPeriodId: self.selectedPeriodId,
            moduleTypeId: (self.currentType || {}).key || self.types[0].key,
            sovEntityInstanceId: self.sovEntityInstanceId
        };
        self[dataURL.method](dataURL, { url: params, urltype: 'obj', body: {} })
            .then(function (r) {
                if (r) {
                    for (var key in r) {
                        if (r.hasOwnProperty(key))
                            self.generalInfo[key] = r[key];
                    }

                    var newEntityInstanceId = self.generalInfo.entityInstanceId || 0;
                    var loadedDifferentEntityInstanceId = self.entityInstanceId && newEntityInstanceId != self.entityInstanceId; 

                    self.entityInstanceId = newEntityInstanceId;
                    self.sovEntityInstanceId = self.generalInfo.sovEntityInstanceId || self.sovEntityInstanceId;
                    self.paymentTypes = r.paymentTypes || [];

                    if (loadedDifferentEntityInstanceId) {
                        self.goToProgressPayment();
                        return;
                    }
                    
                    self.get_RolesDict();

                    // if (r.documentNumber) self.module.name = self.module.baseName + " " + r.documentNumber;
                    if (r.entityInstanceId) {
                        self.getModules();
                        if (r.hasManualDocumentAssignment || r.hasManagerAssignment || r.isClosedState) self.get_assignments();
                        if (r.isClosedState) self.get_signers();
                        if (!r.isDraftState) self.get_assignments_history();
                        if (loadActivity) self.get_activity_summary();
                        self.get_transitionList();
                    }
                    self.operations = userService.getOperationsFor("PP");
                    self.hasManageDrafts = self.operations["Manage Drafts"];
                    self.isDraft = r.isDraftState;
                    self.setEditType(r.defaultPaymentMethod);
                    self.screenId = r.screenId || self.screenId;
                    self.sovEntityInstanceId = r.sovEntityInstanceId || self.sovEntityInstanceId;

                    self.propertiesScreen.isDraftState = !self.generalInfo.isDraftState;
                    self.propertiesScreen.screenId = self.generalInfo.screenId
                    self.propertiesScreen.entityInstanceId = self.entityInstanceId;
                    self.propertiesScreen.init(self.isDraft && !self.generalInfo.approvalId)
                        .then(function () {
                            self.isLoaded = true;

                            self.propertiesScreen.setupForm(self.isDraft && !self.generalInfo.approvalId);

                            if (self.generalInfo.isContractClosedOrArchived || userService.isContractClosed(self.contractId)) {
                                self.propertiesScreen.form.editMode = false;
                            }
                        })

                    self.get_other_drafts();

                    if (self.generalInfo.approvalId && self.generalInfo.canApprove) {
                        self.setupApprovalForm();
                    }
                }
                p.resolve();
            })
            .catch(function (e) {
                console.error(e);
                Message.dberror(e);

                p.reject(e)
            })
            .finally(function () {
                self.isBusy = false;
            })

        return p.promise;
    }

    ProgressPaymentSA.prototype.get_assignments = function () {
        var self = this;
        var dataURL = URI.PROGRESS_PAYMENT.GET_ASSIGNMENT;
        var urlParams = {
            entityInstanceId: self.entityInstanceId || 0,
            contractId: self.contractId || 0
        };
        self.assignments = {
            lookup: {}
        };
        var p = $q.defer();
        self[dataURL.method](dataURL, { url: urlParams, urltype: 'obj' }, { headers: { 'moduleId': self.moduleId } })
            .then(function (r) {
                for (var key in (r || {})) {
                    if (r.hasOwnProperty(key))
                        self.assignments[key] = r[key];
                }
                for (var i = 0; i < (r.manualAssignUsers || []).length; i++) {
                    self.assignments.lookup[r.manualAssignUsers[i].key] = r.manualAssignUsers[i];
                }
                p.resolve();
            })
            .catch(function (e) {
                Message.dberror(e);
                console.error(e);
                p.reject(e);
            });

        return p.promise;

    }

    ProgressPaymentSA.prototype.get_signers = function () {
        var self = this;
        var dataURL = URI.PROGRESS_PAYMENT.GET_SIGNERS;
        var urlParams = {
            entityInstanceId: self.entityInstanceId || 0,
            contractId: self.contractId || 0
        };
        self.signInfo = {
            lookup: {}
        };
        var p = $q.defer();
        self[dataURL.method](dataURL, { url: urlParams, urltype: 'obj' }, { headers: { 'moduleId': self.moduleId } })
            .then(function (r) {
                for (var key in (r || {})) {
                    if (r.hasOwnProperty(key))
                        self.signInfo[key] = r[key];
                }
                for (var i = 0; i < (r.signers || []).length; i++) {
                    self.signInfo.lookup[r.signers[i].key || r.signers[i].id] = r.signers[i];
                }
                p.resolve();
            })
            .catch(function (e) {
                Message.dberror(e);
                console.error(e);
                p.reject(e);
            });

        return p.promise;

    }

    ProgressPaymentSA.prototype.get_assignments_history = function () {
        var self = this;
        var dataURL = URI.PROGRESS_PAYMENT.GET_ASSIGNMENT_HISTORY;
        self.workflow.pastAssignments = [];
        var urlParams = {
            entityInstanceId: self.entityInstanceId || 0,
            contractId: self.contractId || 0
        };

        var p = $q.defer();
        self[dataURL.method](dataURL, { url: urlParams, urltype: 'obj' }, { headers: { 'moduleId': self.moduleId } })
            .then(function (r) {
                for (var i = 0; i < (r || []).length; i++) {
                    if (r[i].validFrom)
                        r[i].validFrom = userService.formatDateTime(r[i].validFrom);
                    if (r[i].validThrough)
                        r[i].validThrough = userService.formatDateTime(r[i].validThrough);
                }

                self.workflow.pastAssignments = r;
                p.resolve();
            })
            .catch(function (e) {
                Message.dberror(e);
                console.error(e);
                p.reject(e);
            });

        return p.promise;

    }

    ProgressPaymentSA.prototype.get_activity_summary = function () {
        var self = this;
        self.reloadActivity = true;
        setTimeout(function() {
            self.reloadActivity = false;
        }, 1000);
    }

    ProgressPaymentSA.prototype.get_transitionList = function () {
        var self = this;
        var dataURL = URI.PROGRESS_PAYMENT.GET_TRANSITIONS;
        var urlParams = {
            workflowId: userService.getWorkflowId(self.moduleId),
            entityInstanceId: self.entityInstanceId || 0,
            paymentPeriodId: self.selectedPeriodId || 0,
            contractId: self.contractId || 0,
            screenId: self.generalInfo.screenId,
        };
        self.workflow.transitions = [];
        self.loadingTransitions = true;
        var p = $q.defer();
        self[dataURL.method](dataURL, { url: urlParams, urltype: 'obj' }, { headers: { 'moduleId': self.moduleId } })
            .then(function (r) {
                self.workflow.transitions = r;
                p.resolve();
            })
            .catch(function (e) {
                Message.dberror(e);
                console.error(e);
                p.reject(e);
            })
            .finally(function () {
                self.loadingTransitions = false;
            })

        return p.promise;

    }

    ProgressPaymentSA.prototype.get_past_transition_info = function (actionInstance) {
        var self = this;
        var p = $q.defer();

        var urlParams = {
            actionInstanceId: actionInstance.key,
            contractId: userService.system.userdata.contractId,
            noFields: actionInstance.isDraft || false
        };
        var dataURL = URI.PROGRESS_PAYMENT.GET_TRANSITION_INSTANCE;
        self[dataURL.method](dataURL, { url: urlParams, urltype: 'obj' }, { headers: { 'moduleId': self.moduleId } })
            .then(function (r) {
                for (var key in (r || {})) {
                    if (r.hasOwnProperty(key))
                        actionInstance[key] = r[key];
                }
                self.set_transition_info(actionInstance);

                p.resolve();
            })
            .catch(function (e) {
                Message.dberror(e);
                console.error(e);
                p.reject(e);
            })
            .finally(function () {
                actionInstance.loading = false;
            });
        return p.promise;
    }

    ProgressPaymentSA.prototype.set_transition_info = function (actionInstance) {
        var self = this;
        if (actionInstance.fields) {
            actionInstance.screen = new WorkflowScreen({
                moduleId: self.moduleId,
                entityInstanceId: self.entityInstanceId,
                contractId: self.contractId,
                onFormInit: function (data) {
                    currencyService.setCurrencyOnFormInit(self, data);
                },
            });
            actionInstance.screen.data = { fields: actionInstance.fields };
            actionInstance.screen.setupForm(false);

            if ((actionInstance.preferredFields || []).length && actionInstance.screen.form.fieldsList) {
                for (var i = 0; i < actionInstance.preferredFields.length; i++) {
                    (actionInstance.screen.form.fieldsList[actionInstance.preferredFields[i].key] || {}).isHighlighted = true;
                }
            }
        }
        if (actionInstance.type == 1 && !actionInstance.stateTypeId) {
            actionInstance.msg = actionInstance.contactEmail 
                ? 'The ' + self.moduleCode + ' was generated from e-mail sent by ' + actionInstance.contactEmail 
                : 'The ' + self.moduleCode + ' draft has entered the workflow';
        }
    }

    ProgressPaymentSA.prototype.assign_User = function (u) {
        var self = this;
        var p = $q.defer();
        self.isAssigningUser = true;
        self[URI.STATE_ASSIGNMENT.ASSIGN_USER.method](URI.STATE_ASSIGNMENT.ASSIGN_USER, { url: { entityInstanceId: self.entityInstanceId, contractId: self.contractId || 0, moduleId: self.moduleId }, urltype: 'obj', body: u })
            .then(function (result) {
                //self.dataOriginalObject = result;
                p.resolve(result);
                self.assignments.assignee = self.assignments.lookup[u.key];
                Message.info('User assignment changed');
                if (result && result.length) {
                    for (var i = 0; i < result.length; i++) {

                        if (result[i].validFrom)
                            result[i].validFrom = userService.formatDateTime(result[i].validFrom);
                        if (result[i].validThrough)
                            result[i].validThrough = userService.formatDateTime(result[i].validThrough);
                    }
                }
                self.workflow.pastAssignments = result;

                self.get_activity_summary();
            })
            .catch(function (e) {
                p.reject(e);
            })
            .finally(function () { self.isAssigningUser = false; });

        return p.promise;
    }

    ProgressPaymentSA.prototype.get_fields = function (trigger) {
        var self = this;
        var p = $q.defer();
        var params = {
            entityInstanceId: self.entityInstanceId,
            // transitionId: transitionId,
            contractId: self.contractId,
            workflowId: userService.getWorkflowId(self.moduleId)
        };
        for (var key in trigger)
            if (trigger.hasOwnProperty(key))
                params[key] = trigger[key];

        var dataURL = URI.PROGRESS_PAYMENT.GET_FIELDS;
        self[dataURL.method](dataURL, { url: params, urltype: 'obj', body: [] })
            .then(function (r) {
                p.resolve(r);
            })
            .catch(function (e) {
                console.error(e);
                p.reject();
            })
        return p.promise;
    }


    ProgressPaymentSA.prototype.get_RolesDict = function () {
        var self = this;
        var p = $q.defer();
        self.rolesDict = [];
        var params = {
            moduleId: self.moduleId,
            contractId: self.contractId
        };
        // self.propertiesScreen = {};
        self.rolesDictLookup = {};
        var dataURL = URI.MODULE.MODULE_ROLES_DICT;
        self[dataURL.method](dataURL, { url: params, urltype: 'obj' })
            .then(function (r) {
                self.rolesDict = r;
                for (var i = 0; i < r.length; i++) {
                    self.rolesDictLookup[r[i].key] = r[i];
                }

                p.resolve();
            })
            .catch(function (e) {
                console.error(e);
                p.reject();
            })
        return p.promise;
    }


    ProgressPaymentSA.prototype.create = function (periodId, screenId, sovEntityInstanceId, fields) {
        var self = this;
        var p = $q.defer();
        var dataURL = URI.PROGRESS_PAYMENT.PP_CREATE;
        var params = {
            contractId: self.contractId,
            paymentPeriodId: periodId || self.selectedPeriodId,
            moduleTypeId: (self.currentType || {}).key || self.types[0].key,
            workflowId: userService.getWorkflowId(self.moduleId),
            screenId: screenId,
            sovEntityInstanceId: sovEntityInstanceId
        };
        self.isBusy = true;
        self[dataURL.method](dataURL, { url: params, urltype: 'obj', body: { values: fields || [], screenId: screenId } })
            .then(function (r) {
                if (r) {
                    self.entityInstanceId = r;
                }

                self.get_general_info();
                Message.info(`${self.moduleName} Request created successfully.`);
                p.resolve();
            })
            .catch(function (e) {
                console.error(e);
                Message.dberror(e);
                p.reject(e);
                self.isBusy = false;
            })
            .finally(function () {

            })

        return p.promise;
    }

    ProgressPaymentSA.prototype.delete = function () {
        var self = this;
        var p = $q.defer();
        var dataURL = URI.PROGRESS_PAYMENT.PP_DELETE;
        var params = {
            contractId: self.contractId,
            entityInstanceId: self.entityInstanceId
        };
        self.isBusy = true;
        self[dataURL.method](dataURL, { url: params, urltype: 'obj' })
            .then(function (r) {
                Message.info(`${self.moduleName} request deleted successfully.`);
                p.resolve();
            })
            .catch(function (e) {
                console.error(e);
                Message.dberror(e);
                p.reject(e);
            })
            .finally(function () {
                self.isBusy = false;
            })

        return p.promise;
    }

    ProgressPaymentSA.prototype.get_periods = function () {
        var self = this;
        var p = $q.defer();
        self.isBusyPeriods = true;
        if (!self.currentPeriod) self.currentPeriod = { id: 0, name: 'Current Period' };
        Dictionaries.PPPeriods({ contractId: self.contractId, ppEntityInstanceId: self.entityInstanceId, sovEntityInstanceId: self.sovEntityInstanceId })
            .then(function (r) {
                if (r && r.length) {
                    if (r && r.length && self.currentPeriod) {
                        for (var i = 0; i < r.length; i++) {
                            r[i].startDate = r[i].startDate ? userService.formatDate(r[i].startDate) : "";
                            r[i].endDate = r[i].startDate ? userService.formatDate(r[i].endDate) : "";
                            if (r[i].key == self.currentPeriod.id) {
                                r[i].current = true;
                            }
                        }
                    }
                    if (!self.currentPeriod.id) r.splice(0, 0, { key: 0, value: 'Current Period', current: true });
                    self.periodsDict = r;
                    // self.currentPeriod.value = self.periodsDict[0].value;
                } else self.periodsDict = [];

                p.resolve();
            })
            .catch(function (e) {
                console.error(e);
                Message.dberror(e);
                p.reject(e);
            })
            .finally(function () {
                self.isBusyPeriods = false;
            })

        return p.promise;
    }

    ProgressPaymentSA.prototype.get_currentPeriod = function () {
        var self = this;
        var p = $q.defer();
        var dataURL = URI.PROGRESS_PAYMENT.PPD_CURRENT;
        self[dataURL.method](dataURL, { url: { contractId: self.contractId }, urltype: 'obj' })
            .then(function (r) {
                r.startDate = r.startDate ? userService.formatDate(r.startDate) : "";
                r.endDate = r.startDate ? userService.formatDate(r.endDate) : "";
                self.currentPeriod = r;
                self.get_periods();
                p.resolve();
            })
            .catch(function (e) {
                console.error(e);
                Message.dberror(e);
                p.reject(e);
            })
            .finally(function () {

            })

        return p.promise;
    }

    ProgressPaymentSA.prototype.printDocument = function () {
        var self = this;

        var row = {
            entity_instance_id: self.entityInstanceId,
            closed_on: self.generalInfo.isClosedState ? 'yes' : null,
            screen_id: self.generalInfo.screenId,
        };
        self.pdfHandler.printDocuments(row);
    }

    ProgressPaymentSA.prototype.downloadPdfs = function () {
        var self = this;

        var contractNo = userService.system.context.contract?.no;
        var name = self.moduleName + '-' + contractNo;

        var row = {
            entity_instance_id: self.entityInstanceId,
            closed_on: self.generalInfo.isClosedState ? 'yes' : null,
            screen_id: self.generalInfo.screenId,
            fileName: name,
        };
        self.pdfHandler.download(row);
    }

    ProgressPaymentSA.prototype.emailPdfs = function (scope) {
        var self = this;

        var contractNo = userService.system.context.contract?.no;
        var name = self.moduleName + '-' + contractNo;

        var row = {
            entity_instance_id: self.entityInstanceId,
            closed_on: self.generalInfo.isClosedState ? 'yes' : null,
            screen_id: self.generalInfo.screenId,
            fileName: name,
        };
        self.pdfHandler.email(row);
    }

    ProgressPaymentSA.prototype.excludeRolesFromTransition = function (t) {
        var self = this;
        t.exclusionRoles = angular.copy(self.rolesDict);
        t.showExcludeRoles = true;
        if ((t.roleToExcludeIds || []).length) {
            for (var i = 0; i < t.exclusionRoles.length; i++) {
                if (t.roleToExcludeIds.indexOf(t.exclusionRoles[i].key) != -1)
                    t.exclusionRoles[i].isUsed = true;
            }
        }
    }

    ProgressPaymentSA.prototype.cancelExcludeRoles = function (t) {
        t.showExcludeRoles = false;
    }

    ProgressPaymentSA.prototype.syncExcludeRoles = function (t) {
        var self = this;
        var p = $q.defer();
        var dataURL = URI.MODULE.SYNC_EXCLUDED_ROLES;
        var roleToExcludeIds = [];
        for (var i = 0; i < t.exclusionRoles.length; i++) {
            if (t.exclusionRoles[i].isUsed)
                roleToExcludeIds.push(t.exclusionRoles[i].key);
        }
        var params = {
            url: {
                moduleId: self.moduleId,
                actionInstanceId: t.actionInstanceId,
                contractId: self.contractId
            },
            body: roleToExcludeIds,
            urltype: 'obj'
        }
        self[dataURL.method](dataURL, params)
            .then(function (result) {
                t.roleToExcludeIds = roleToExcludeIds;
                t.showExcludeRoles = false;
                p.resolve();
            })
            .catch(function (e) {
                p.reject(e);
            });
        return p.promise;
    }

    ProgressPaymentSA.prototype.sign_Doc = function () {
        var self = this;
        var p = $q.defer();
        var dataURL = URI.MODULE_SIGNATURE.GET;
        var signId;
        self.signatureOptions = {
            sign: false
        };
        for (var i = 0; i < self.signInfo.signers.length; i++) {
            if (self.signInfo.signers[i].id == userService.system.userdata.id && !self.signInfo.signers[i].signed) {
                signId = self.signInfo.signers[i].signId;
                break;
            }
        }
        self[dataURL.method](dataURL, { id: signId })
            .then(function (result) {
                self.signatureOptions = {
                    sign: true,
                    signatureId: result.signId,
                    clientId: result.clientId,
                    url: result.signatureUrl,
                    // redirect: true,
                    isProd: result.isProd,
                    setSigned: function (sid) {
                        self.put(URI.MODULE_SIGNATURE.SET_SIGNED, { url: { id: sid }, urltype: 'obj' })
                            .then(function () { self.get_general_info(); })
                            .catch(function (e) { console.error(e) })
                    },
                    callback: function () {

                        return;
                    }
                };
            })
            .catch(function (e) {
                Message.dberror(e);
            });
    }

    // payment related

    var processColumns = function (r, moduleId) {
        var columns = [];
        if (r && r.length) {
            // setup width, for SOVI we need the same button column
            var widthBits = moduleId == MODULE_SOVI ? 1: 0;
            for (var i = 0; i < r.length; i++) {
                if (!r[i].isFilter) {
                    r[i].width = r[i].width || 1;
                    widthBits += parseInt(r[i].width);
                }
            }

            for (var i = 0; i < r.length; i++) {

                r[i].formattingsMapping = {};
                r[i].restrictionsMapping = {};
                if ((r[i].formattings || []).length) {
                    for (var j = 0; j < r[i].formattings.length; j++) {
                        r[i].formattingsMapping[r[i].formattings[j].key] = r[i].formattings[j].value || r[i].formattings[j].formattingValue;
                    }
                }
                if ((r[i].restrictions || []).length) {
                    for (var j = 0; j < r[i].restrictions.length; j++) {
                        r[i].restrictionsMapping[r[i].restrictions[j].key] = r[i].restrictions[j].value;
                    }
                }

                //set flags
                if ((1 & r[i].priority) != 0) r[i].onPhone = true;
                else r[i].onPhone = false;
                if ((2 & r[i].priority) != 0) r[i].onTablet = true;
                else r[i].onTablet = false;

                var type = function (column) {
                    if (column.typeId == 2) {
                        if (column.formattingsMapping[1] == 2) return 'money';
                        if (column.formattingsMapping[1] == 3) return 'percentage';
                        if (column.formattingsMapping[1] == 1) return 'number';
                    }
                    if (column.typeId == 4) return 'date';
                    if (column.name == 'state_name') return 'stateName';
                    if (column.showThumbnail) return 'thumbnail';
                    return 'text';
                };

                if (type(r[i]) == 'date') {
                    if (r[i].restrictionsMapping[5] == 3)
                        r[i].options = { format: userService.userSettings().dateFormat };
                    else if (r[i].restrictionsMapping[5] == 5)
                        r[i].options = { format: userService.userSettings().timeFormat };
                    else r[i].options = { format: userService.userSettings().datetimeFormat };
                }

                columns.push({
                    width: 100 / widthBits * r[i].width,
                    onPhone: r[i].name == "payment_amount" || r[i].name == "payment_percent" ? true : r[i].onPhone,
                    onTablet: r[i].name == "payment_amount" || r[i].name == "payment_percent" ? true : r[i].onTablet,
                    id: r[i].id,
                    name: r[i].id > 0 ? r[i].id : r[i].name,
                    label: r[i].label,
                    type: type(r[i]),
                    isFilter: r[i].isFilter,
                    isDate: type(r[i]) == 'date',
                    isPercent: type(r[i]) == 'percentage',
                    isPayment: r[i].isPayment || type(r[i]) == 'money',
                    isNumber: r[i].isPayment || type(r[i]) == 'number',
                    isEditableAmount: r[i].isEditableAmount || r[i].name == "payment_amount" ? true : false,
                    isEditablePercentage: r[i].isEditablePercentage || r[i].name == "payment_percent" ? true : false,
                    isEditableQuantity: r[i].isEditableQuantity || r[i].name == "payment_qty" ? true : false,
                    typeId: r[i].typeId,
                    fieldTypeId: r[i].fieldTypeId,
                    formattings: r[i].formattings,
                    formattingsMapping: r[i].formattingsMapping,
                    restrictions: r[i].restrictions,
                    restrictionsMapping: r[i].restrictionsMapping,
                    visible: true,
                    isPrimarySort: r[i].isPrimarySort,
                    isDescending: r[i].isDescending,
                    canBeModifiedOnPP: r[i].canBeModifiedOnPP,
                    options: r[i].options,
                    decimals: r[i].formattingsMapping[2]
                });
            }

            const anyModifyingColumns = columns.some(c => c.canBeModifiedOnPP);
            // add save button column
            if (moduleId == MODULE_SOVI && anyModifyingColumns) {
                columns.push({
                    width: 100 / widthBits * 1,
                    onPhone: true,
                    onTablet: true,
                    id: 0,
                    name: "Save Button",
                    type: "button",
                    visible: true
                });
            }
        }

        return columns;
    }

    var processFields = function (row, columnsLookup) {
        for (var key in row) {
            if (row.hasOwnProperty(key) && typeof columnsLookup[key] != 'undefined') {
                if (row[key] !== "" && row[key] !== null && typeof row[key] != "undefined") {
                    if (columnsLookup[key].typeId == 3)
                        row[key] = ([true, false].indexOf(row[key]) != -1) ? (row[key] ? "Yes" : "No") : row[key];
                    else if (columnsLookup[key].typeId == 2 && (columnsLookup[key].isPayment || columnsLookup[key].isPercent))
                        row[key] = (row[key] || "") * 1;
                    //date
                    else if (columnsLookup[key].type == 'thumbnail') {
                        if (row[key] && row[key + '_thumb'])
                            row[key + '_thumb'] = '<span class=""><img src="data:'
                                + 'image/jpeg;base64,'
                                + row[key + '_thumb'] + '" />'
                                + '</span>';
                        else {
                            row[key] = "-";
                            row[key + '_thumb'] = "<i title='Thumbnail Missing' class='neutralText mdi mdi-image-minus'></i>";
                        }
                    }

                    else row[key] = (row[key] || "").toString();

                } else {
                    row[key] = '-';
                }
            }
        }
        return row;
    }

    var parseData = function (data, columns) {
        var data = data || [], retval = [], columnsLookup = {}, columns = columns || [];
        for (var j = 0; j < columns.length; j++) columnsLookup[columns[j].name] = columns[j];
        for (var i = 0; i < data.length; i++) retval.push(processFields(data[i], columnsLookup));
        return retval;
    }

    ProgressPaymentSA.prototype.search = function () {
        var self = this;
        for (var i = 0; i < self.modulesList.length; i++) {
            if (self.modulesList[i].moduleId) {
                self.modulesList[i].isExpanded = true;
                self.toggleModuleItems(self.modulesList[i], 1);
            }
        }
    }

    ProgressPaymentSA.prototype.getModulePages = function (m) {
        var self = this;
        var dataURL = URI.PROGRESS_PAYMENT.PPI_PAGES;
        var p = $q.defer();

        if (!m.relationId || m.customPagesInfo) {
            m.customPagesInfo = m.customPagesInfo || self.generateCustomPagesInfo(m.itemsCount, self.pageSize);
            p.resolve();
            return p.promise;
        }

        var params = {
            progressPaymentEntityInstanceId: self.entityInstanceId,
        };
        var bodyParams = {
            criteria: self.searchTerm || "",
            isCurrent: false,
            pagesize: self.pageSize
        }

        m.loading = true;
        if (m.moduleId) params.moduleId = m.moduleId;
        if (self.editMode || self.isAllPayments) params.editMode = true;

        self[dataURL.method](dataURL, { url: params, urltype: 'obj', body: bodyParams })
            .then(function (r) {
                // We need custom pages for other modules, we don't need them for SOVI
                if (m.moduleId != MODULE_SOVI) {
                    m.customPagesInfo = r;
                }
                p.resolve();
            })
            .catch(function (e) {
                console.error(e);
                Message.dberror(e);
                m.message = "An error has occured while loading page data.";
                p.reject(e);
            })
        return p.promise;
    }

    ProgressPaymentSA.prototype.generateCustomPagesInfo = function (itemsCount, pageSize) {
        itemsCount ??= 0;
        pageSize ??= 1;

        var result = [];

        // in case we have only one page, then we just need to create one custom page info
        if (itemsCount <= pageSize) {
            result.push({ offset: 0, pageNo: 1, pageSize: itemsCount, parentItems: itemsCount });
        }
        else {
            // we have multiple pages, we need to split pages
            var nrOfPages = itemsCount / pageSize;

            for (var i = 0; i < nrOfPages; i++) {

                if (i == (nrOfPages - 1)) {
                    var _itemsCount = itemsCount - ((i + 1) * pageSize);
                    result.push({ offset: i * pageSize, pageNo: i + 1, pageSize: _itemsCount, parentItems: _itemsCount });
                }
                else {
                    result.push({ offset: i * pageSize, pageNo: i + 1, pageSize: pageSize, parentItems: pageSize });
                }
            }
        }

        return result;
    }

    ProgressPaymentSA.prototype.togglePartials = function (item) {
        var self = this;
        for (var i = 0; i < item.partials.length; i++) {
            item.partials[i].isHideChildren = !item.partials[i].isHideChildren;
        }
        item.hasChildrenHidden = item.partials[0].isHideChildren;
    }

    ProgressPaymentSA.prototype.toggleModuleItems = function (m, pageNo, wbsNode) {
        var self = this;

        // This will refresh the items and changes will be lost
        var anyChanges = self.anyChangesOnItems(m);
        if (anyChanges) {
            return;
        }

        self.getModulePages(m)
            .then(function () {
                self.toggleModuleItemsInternal(m, pageNo, wbsNode);
            })
            .catch(function () {
                self.toggleModuleItemsInternal(m, pageNo, wbsNode);
            });
    }

    ProgressPaymentSA.prototype.toggleModuleItemsInternal = function (m, pageNo, wbsNode) {
        var self = this;
        var dataURL = m.isWBS && m.layout == 2
                        ? URI.PROGRESS_PAYMENT.PPI_RETRIEVE_WBS
                        : !m.isAdjustments 
                            ? URI.PROGRESS_PAYMENT.PPI_RETRIEVE 
                            : URI.ADJUSTMENTS.SEARCH_PP;
        m.message = null;

        if (!pageNo) m.isExpanded = !m.isExpanded;

        var setPagination = function (m, count, pageNo) {
            if (pageNo) {
                if (pageNo <= 0) pageNo = 1;
                if (pageNo > m.pages) pageNo = m.pages;
            }
            m.currentPage = pageNo || 1;

            if (m.customPagesInfo) {
                var currentCustomPageInfo = m.customPagesInfo[m.currentPage - 1];
                m.totalCount = m.customPagesInfo.reduce((a, i) => a + i.parentItems, 0);
                m.pages = m.customPagesInfo.length;
                m.page = currentCustomPageInfo.offset;
                m.pageStart = [...m.customPagesInfo].splice(0, m.currentPage - 1).reduce((a, i) => a + i.parentItems, 0) + 1;
                m.pageEnd = [...m.customPagesInfo].splice(0, m.currentPage).reduce((a, i) => a + i.parentItems, 0);
                m.pageSize = currentCustomPageInfo.pageSize;
            }
            else {
                if (!count) return;
                
                m.totalCount = count;
                m.pages = Math.ceil(count / self.pageSize);
                m.page = pageNo || 1;
                m.pageStart = self.pageSize * (m.currentPage - 1) + 1;
                m.pageEnd = self.pageSize * m.currentPage < count ? self.pageSize * m.currentPage : count;
                m.pageSize = self.pageSize;
            }
        }

        setPagination(wbsNode ? wbsNode : m, wbsNode?.sovItemCount || m.itemsCount, pageNo);

        if (m.isExpanded) {
            if (m.isWBS && m.layout == 2 && !wbsNode) {
                m.items = [];
                self.get_wbs(m);
            } else {
                var params = {
                    contractId: self.contractId,
                    progressPaymentEntityInstanceId: self.entityInstanceId,
                    sovWbsId: wbsNode?.id
                };
                var bodyParams = {
                    criteria: self.searchTerm || "",
                    isCurrent: false,
                    page: wbsNode ? wbsNode.page : m.page,
                    pagesize: wbsNode ? wbsNode.pageSize : m.pageSize
                }
                if (m.moduleId) params.moduleId = m.moduleId;
                if (self.editMode || self.isAllPayments) params.editMode = true;
                m.loading = true;
                m.loadingItems = true;
                self[dataURL.method](dataURL, { url: params, urltype: 'obj', body: bodyParams })
                    .then(function (r) {

                        setPagination(wbsNode ? wbsNode : m, wbsNode?.sovItemCount || r.records, pageNo);

                        if (wbsNode) {
                            wbsNode.items = [];
                        } else {
                            m.items = [];
                        }
                        if (((r || {}).data || []).length) {
                            if (wbsNode) {
                                wbsNode.blockingStateName = r.data[0].blockingStateName || "";
                                wbsNode.blockingUsername = r.data[0].blockingUsername || "";
                                wbsNode.isBlocked = r.data[0].isBlocked || false;
                            } else {
                                m.blockingStateName = r.data[0].blockingStateName || "";
                                m.blockingUsername = r.data[0].blockingUsername || "";
                                m.isBlocked = r.data[0].isBlocked || false;
                            }
                        }
                        if (!m.isAdjustments) {
                            if (((r || {}).data || []).length) {
                                var items = [];

                                for (var i = 0; i < r.data[0].items.length; i++) {
                                    var currentMainItem = r.data[0].items[i];

                                    self.ppiLookup[currentMainItem.child_entity_instance_id] = currentMainItem;
                                    items.push(currentMainItem);

                                    if ((currentMainItem.items || []).length) {
                                        //has partials
                                        var partials = [];
                                        currentMainItem.readonly = true;
                                        for (var j = 0; j < currentMainItem.items.length; j++) {
                                            if (currentMainItem.items[j].moduleId == 0) { // itself as child
                                                items.push(currentMainItem.items[j].items[0]);
                                                partials.push(currentMainItem.items[j].items[0]);
                                            }
                                            else {
                                                items.push(currentMainItem.items[j]);
                                                partials.push(currentMainItem.items[j]);
                                            }
                                            if (currentMainItem.items[j].fields) {
                                                currentMainItem.items[j].fields = processColumns(currentMainItem.items[j].fields, m.moduleId);
                                            }
                                        }

                                        currentMainItem.partials = partials;
                                    }
                                }

                                if (wbsNode) {
                                    wbsNode.items = parseData(items, m.fields);
                                } else {
                                    m.items = parseData(items, m.fields);
                                }
                            }

                            if (((r || {}).data || []).length && r.data[0].totals) {
                                if (wbsNode){
                                    wbsNode.totals = r.data[0].totals;
                                } else {
                                    m.totals = r.data[0].totals;
                                }
                                self.modulesLookup[m.relationId].totals = m.totals;
                            }

                        } else {
                            // adjustments
                            var itemsLookup = {};
                            m.totals = {};

                            if (r.totals) {
                                for (var key in r.totals) {
                                    m.totals[key] = r.totals[key]
                                }
                                self.modulesLookup[r.relationId].totals = m.totals;
                            }
                            m.totals.amount = r.totalPayment || r.total_payment;
                            for (var i = 0; i < (r.items || []).length; i++) {
                                itemsLookup[r.items[i].id] = r.items[i];
                                if (r.items[i].type == 1) {
                                    m.hasRecurring = true;
                                }
                            }

                            m.items = r.items;
                            m.itemsLookup = itemsLookup;
                        }
                        if (wbsNode) {
                            (wbsNode.items || []).forEach(function(item) { self.PPIprocessPaymentFields(m, item); });
                        } else {
                            (m.items || []).forEach(function(item) { self.PPIprocessPaymentFields(m, item); });
                        }
                    })
                    .catch(function (e) {
                        console.error(e);
                        Message.dberror(e);
                        m.message = "An error has occured while loading data.";
                    })
                    .finally(function () {
                        m.loading = false;
                        m.loadingItems = false;
                    })
            }
        } else {
            m.items = null;
        }
    }

    ProgressPaymentSA.prototype.getModules = function () {
        var self = this;
        self.message = null;
        var dataURL = URI.PROGRESS_PAYMENT.PP_RELATIONS;
        
        self.isBusy = true;
        self.isModulesLoaded = false;
        var params = {
            contractId: self.contractId,
            progressPaymentEntityInstanceId: self.entityInstanceId,
            editMode: false
        };
        if (self.editMode || self.isAllPayments) params.editMode = true;
        self[dataURL.method](dataURL, { url: params, urltype: 'obj' })
            .then(function (r) {
                self.totals = {};
                for (var key in (r || {}).ppTotals) {
                    if (r.ppTotals.hasOwnProperty(key)) {
                        self.totals[key] = r.ppTotals[key];
                    }
                }
                self.totalsDecimals = { paymentAmount: r.totalsDecimals?.paymentAmount, paymentPercent: r.totalsDecimals?.paymentPercent, paymentTotal: r.totalsDecimals?.paymentTotal, paymentQty: r.totalsDecimals?.paymentQty };
                if (((r || {}).modules || []).length) {
                    for (var i = 0; i < r.modules.length; i++) {
                        var module = r.modules[i];

                        if (module.moduleId == MODULE_SOVI) {
                            self.hasPaymentQuantityFields = module.fields.some(f => self.quantityFieldsId.includes(f.id));
                            self.hasPaymentPercentageFields = module.fields.some(f => self.percentageFieldsId.includes(f.id));
                            self.hasPaymentAmountFields = module.fields.some(f => self.amountFieldsId.includes(f.id));
                            if (r.modules[i].isWBS) {
                                r.modules[i].layout = 2; // wbs layout
                            }
                        }

                        if (module.moduleId == MODULE_ADJUSTMENTS) {
                            module.isAdjustments = true;

                            var totals = {
                                amount: 0,
                            };
                            for (var j = 0; j < (r.releases.items || []).length; j++) {
                                totals.amount = totals.amount + r.items[j].amount;
                                r.releases.items[j] = new AdjustmentItem(r.releases.items[j], { modulesLookup: self.modulesLookup, itemsLookup: self.itemsLookup, ppiLookup: self.ppiLookup, totals: self.totals }, self.entityInstanceId);
                            }
                        }

                        module.fields = processColumns(module.fields, module.moduleId);
                        self.modulesLookup[module.relationId] = module;
                    }
                }

                // check if default payment method is valid, if not set to first available
                if (self.paymentTypes.length && !self.paymentTypes.some(p => p.key == self.editType)) {
                    self.setEditType(self.paymentTypes[0].key);
                }

                self.modulesList = r.modules;

                if (r.modules.some(a => a.isAdjustments) && self.generalInfo.autoExpandeAdjustments)
                     self.toggleModuleItems(self.modulesList[r.modules.findIndex(a => a.isAdjustments)], null);

                if (r.modules.some(a => !a.isAdjustments)) 
                    self.toggleModuleItems(self.modulesList[r.modules.findIndex(a => !a.isAdjustments)], null);

                self.showHideColumns();
            })
            .catch(function (e) {
                console.error(e);
                Message.dberror(e);
                self.message = e.data.messages;
            })
            .finally(function () {
                self.isBusy = false;
                self.isModulesLoaded = true;
            })
    }

    ProgressPaymentSA.prototype.toggleEditMode = function () {
        var self = this;
        if (self.editMode || self.isAllPayments) self.get_activity_summary();
        self.editMode = !self.editMode;
        self.propertiesScreen.form.editMode = self.editMode;
        self.getModules();
    }

    // pp items
    ProgressPaymentSA.prototype.PPIsave = function (item) {
        var self = this;
        item.loading = true;

        if (typeof item.adjustment_available_to_pay != 'undefined') {
            self.AIsave(item);
        } else {
            self.MIsave(item);
        }
    }

    ProgressPaymentSA.prototype.processPPIValues = function (item, module) {
        var values = Object.keys(item)
                        // keep only keys that are pure numbers
                        .filter(k => {
                            var canBeModified = module.fields.find(f => f.id == k && f.canBeModifiedOnPP);
                            return /^[0-9]+$/.test(k) && canBeModified;
                        })
                        // build array of { id, value }
                        .map(k => ({ id: Number(k), value: item[k] }));

        // Union with the ones that didn't have value changed, the ones that didnt exists in item
        var fieldIds = values.map(v => v.id);
        
        // Add fields with empty value
        values.push(...module.fields.filter(f => f.canBeModifiedOnPP && !fieldIds.includes(f.id)).map(f => ({ id: f.id, value: null })) || []);

        // Return values
        return values;
    }

    ProgressPaymentSA.prototype.PPISaveValues = function (item, module) {
        var self = this;
        var p = $q.defer();
        var dataURL = URI.PROGRESS_PAYMENT.SAVE_ITEM_VALUES;

        var saveParams = {
            relationInstanceId: item.relation_instance_id,
            progressPaymentEntityInstanceId: self.entityInstanceId,
        };
        var body = { 
            values: self.processPPIValues(item, module) || [],
        }

        item.loading = true;
        self[dataURL.method](dataURL, { url: saveParams, urltype: 'obj', body: body })
            .then(function (r) {
                item.loading = false;
                self.PPISaveProcessResponse(r, item, false);
                p.resolve(r);
            })
            .catch(function (e) {
                console.error(e);
                Message.dberror(e);
                item.loading = false;
                p.reject(e)
            })

        return p.promise;
    }

    ProgressPaymentSA.prototype.updateScreen = function () {
        var self = this;
        var p = $q.defer();
        if (!self.editMode) {
            p.resolve();
            return p.promise;
        }
        self.propertiesScreen.form.validate();
        // perform saving the form only if is valid and there is a change in the form
        if (self.propertiesScreen.form.isValid && self.propertiesScreen.form.dirty) {
            self.propertiesScreen.form.loading = true;
            var params = {
                url: {
                    moduleId: self.moduleId,
                    entityInstanceId: self.entityInstanceId,
                    contractId: self.contractId
                },
                body: {
                    values: self.propertiesScreen.valuesDictionary,
                    workflowGroupId: self.workflowGroupId,
                    emails: [],
                    groups: [],
                    roleToExcludeIds: []
                },

                urltype: 'obj'
            }

            var dataURL = URI.MODULE.UPDATE;
            self[dataURL.method](dataURL.toString(), params)
                .then(function () {
                    self.isModified = true;
                    self.propertiesScreen.form.loading = false;
                    self.propertiesScreen.form.clearDirty();
                    self.get_activity_summary();
                    p.resolve();
                }).catch(function (e) {
                    self.propertiesScreen.form.catch(e);
                    self.propertiesScreen.form.loading = false;
                    p.reject(e);
                })
        }
        else if (!self.propertiesScreen.form.isValid) {
            p.reject();
        }
        else if (!self.propertiesScreen.form.dirty) {
            p.resolve();
        }
        return p.promise;
    }

    // module item
    ProgressPaymentSA.prototype.MIsave = function (item) {
        var self = this;
        item.loading = true;

        var dataURL = URI.PROGRESS_PAYMENT.PPI_UPDATE;
        var toSend = {
            progressPaymentEntityInstanceId: self.entityInstanceId,
            payment_percent: null,
            payment_amount: null,
            payment_qty: null,
            child_entity_instance_id: item.child_entity_instance_id,
            parent_child_entity_instance_id: item.parent_child_entity_instance_id,
            relation_id: item.relation_id,
            relation_instance_id: item.relation_instance_id,
            isParentSubItem: item.isParentSubItem
        }
        var fieldName = item.editingAmount ? 'payment_amount' : item.editingPercentage ? 'payment_percent' : item.editingQuantity ? 'payment_qty' : '';
        if (fieldName) {
            toSend[fieldName] = item[fieldName] || 0;
        }
        // send value only if something was changed
        if (item.changed) {
            var module = self.modulesLookup[item.relation_id];
            toSend.values = self.processPPIValues(item, module) || [];
        }

        var params = { contractId: userService.system.userdata.contractId };
        if (self.editMode || self.isAllPayments) params.editMode = true;

        self[dataURL.method](dataURL, { url: params, urltype: 'obj', body: toSend })
            .then(function (r) {
                self.PPISaveProcessResponse(r, item, true);

                Message.info('Payment item updated successfully');
            })
            .catch(function (e) {
                Message.dberror(e);
                console.error(e);
                if (item.editingAmount) {
                    item.payment_amount = item.bkp;
                } else if (item.editingPercentage) {
                    item.payment_percent = item.bkp;
                } else if (item.editingQuantity) {
                    item.payment_qty = item.bkp;
                }
                self.PPIprocessPaymentFields(self.modulesLookup[item.relation_id], item);
            })
            .finally(function () { item.loading = false; })

    }

    ProgressPaymentSA.prototype.PPISaveProcessResponse = function (r, item, setTotals) {
        var self = this;

        // We save the item, now it is not changed anymore until user changes it again
        item.changed = false;

        if (r) {
            self.get_activity_summary();
            var adjustmentsModuleRelationId = self.modulesList.find(a => a.isAdjustments)?.relationId;
            if (self.modulesLookup[adjustmentsModuleRelationId] && self.modulesLookup[adjustmentsModuleRelationId].hasRecurring && self.modulesLookup[adjustmentsModuleRelationId].isExpanded) {
                self.toggleModuleItems(self.modulesLookup[adjustmentsModuleRelationId], self.modulesLookup[adjustmentsModuleRelationId].currentPage)
            }

            self.ppiLookup[r.items[0].child_entity_instance_id].loading = true;

            $timeout(function () {
                self.ppiLookup[r.items[0].child_entity_instance_id].loading = false;
            }, 3000)

            for (var key in (r.items || [])[0]) {
                if (r.items[0].hasOwnProperty(key)) {
                    self.ppiLookup[r.items[0].child_entity_instance_id][key] = r.items[0][key];
                }
            }
            // we need to clear all fields that are not in result to avoid keeping old values in case they are not sent by backend anymore
            for (var key in self.ppiLookup[r.items[0].child_entity_instance_id]) {
                var column = self.modulesLookup[r.items[0].relation_id].fields.find(f => f.id == key);
                if (column && column.canBeModifiedOnPP && !r.items[0].hasOwnProperty(key)) {
                    self.ppiLookup[r.items[0].child_entity_instance_id][key] = null;
                }
            }
            // partials
            if (parseInt(item.level) != 1 || item.IsParentSubItem) {

                var processResponse = function () {
                    for (var i = 0; i < r.items[0].items.length; i++) {
                        for (var j = 0; j < r.items[0].items[i].items.length; j++) {
                            if (r.items[0].items[i].items[j].child_entity_instance_id == item.child_entity_instance_id) {
                                for (var key in r.items[0].items[i].items[j]) {
                                    if (r.items[0].items[i].items[j].hasOwnProperty(key))
                                        item[key] = r.items[0].items[i].items[j][key];
                                }
                                return;

                            }
                        }
                    }
                }

                processResponse();
            }

            var module = self.modulesLookup[r.items[0].relation_id];

            if (setTotals) {
                if (!module.isWBS || module.isWBS && module.layout == 1) {
                    for (var key1 in r.ppTotals) if (r.ppTotals.hasOwnProperty(key1)) self.totals[key1] = r.ppTotals[key1];
                    for (var key2 in r.totals) if (r.totals.hasOwnProperty(key2)) module.totals[key2] = r.totals[key2];
                    module["total_payment"] = module.totals["total_payment"];
                    module["payment_amount"] = module.totals["payment_amount"];
                } else {
                    self.get_wbs(module, true);
                }
            }
            
            self.PPIprocessPaymentFields(module, item);
        }
    }

    ProgressPaymentSA.prototype.PPIprocessPaymentFields = function (module, item) {
        var self = this;
        this.PPIprocessPaymentField(module, item, 'payment_amount');
        this.PPIprocessPaymentField(module, item, 'payment_percent');
        this.PPIprocessPaymentField(module, item, 'payment_qty');

        var partials = (item.partials || []).filter(p => p.moduleId && p.totals && (p.items || []).length);
        partials.forEach(function(partial) { 
            (partial.items || []).forEach(function(partialItem) { 
                self.PPIprocessPaymentFields(module, partialItem); 
            });
        });
    }

    ProgressPaymentSA.prototype.PPIprocessPaymentField = function (module, item, name) {
        var self = this;

        var decimals = module.isAdjustments ? 2
                : name == 'payment_amount' ? self.totalsDecimals.paymentAmount 
                : name == 'payment_percent' ? self.totalsDecimals.paymentPercent 
                : name == 'payment_qty' ? self.totalsDecimals.paymentQty 
                : 2;

        if (name) {
            item[name + '_decimals'] = decimals;
            item[name + '_editing'] = userService.formatNumber(item[name], decimals, false, false, false);
        }
    }

    ProgressPaymentSA.prototype.PPIonFocus = function (module, item) {
        var self = this;
        item.focus = true;
        item.editingPercentage = self.isEditablePercentage;
        item.editingAmount = self.isEditableAmount;
        item.editingQuantity = self.isEditableQuantity;

        var fieldName = self.isEditableAmount ? 'payment_amount' : self.isEditablePercentage ? 'payment_percent' : self.isEditableQuantity ? 'payment_qty' : '';
        if (fieldName) {
            var field = item[fieldName];
            item.bkp = field;
            if (!field) field = null;
            self.PPIprocessPaymentField(module, item, fieldName);
        }
    }

    ProgressPaymentSA.prototype.onFocusNumber = function (item) {
        item.focus = true;
    }

    ProgressPaymentSA.prototype.onBlurNumber = function (item) {
        item.focus = false;
    }

    ProgressPaymentSA.prototype.PPIonBlur = function (item) {
        var self = this;
        item.focus = false;

        var fieldName = self.isEditableAmount ? 'payment_amount' : self.isEditablePercentage ? 'payment_percent' : self.isEditableQuantity ? 'payment_qty' : '';
        if (fieldName) {
            var field = userService.revertLocaleNumber(item[fieldName + '_editing']);
            item[fieldName] = field;
            if (!field) {
                field = 0;
                if (item.bkp) self.PPIsave(item);
            } else {
                if (item.bkp != field) self.PPIsave(item);
            }
        }
    }

    ProgressPaymentSA.prototype.PPIsubmit = function (event) {
        if (event) event.target.blur();
    }

    ProgressPaymentSA.prototype.onItemTouched = function (item) {
        if (item) item.wasTouched = true;
    }

    ProgressPaymentSA.prototype.onItemChange = function (item, col, module) {
        if (module.loadingItems || !item.wasTouched) return;
        if (item) item.changed = true;
        if (col && col.type == 'date' && item[col.id] instanceof moment) {
            item[col.id] = userService.formatDateToIsoBasedOnRestrictionsLookup(item[col.id], col.restrictionsMapping);
        }
    }

    // adjustments items

    ProgressPaymentSA.prototype.AIsave = function (item) {
        var self = this;
        var params = {
            progressPaymentEntityInstanceId: self.entityInstanceId,
            contractId: userService.system.userdata.contractId,
            editMode: self.editMode || self.isAllPayments
        }
        var toSend = angular.copy(item);
        toSend.payment_percent = 0;
        toSend.payment_amount = 0;
        toSend.payment_qty = 0;

        var fieldName = item.editingAmount ? 'payment_amount' : item.editingPercentage ? 'payment_percent' : item.editingQuantity ? 'payment_qty' : '';
        if (fieldName) {
            toSend[fieldName] = item[fieldName] || 0;
        }
        
        var adjustmentsModuleRelationId = self.modulesList.find(a => a.isAdjustments)?.relationId;
        self.modulesLookup[adjustmentsModuleRelationId].isBusy = true;
        item.loading = true;
        var dataURL = URI.ADJUSTMENTS.PAY_ADJUSTMENT;
        self[dataURL.method](dataURL, { url: params, urltype: 'obj', body: toSend })
            .then(function (r) {
                for (var key in r.ppTotals) if (r.ppTotals.hasOwnProperty(key)) self.totals[key] = r.ppTotals[key];
                for (var key in r.items[0]) if (r.items[0].hasOwnProperty(key)) item[key] = r.items[0][key];
                for (var key2 in r.totals) if (r.totals.hasOwnProperty(key2)) self.modulesLookup[adjustmentsModuleRelationId].totals[key2] = r.totals[key2];
                self.modulesLookup[adjustmentsModuleRelationId]["total_payment"] = r["total_payment"];
                self.modulesLookup[adjustmentsModuleRelationId]["payment_amount"] = r["payment_amount"];
                self.PPIprocessPaymentFields(self.modulesLookup[adjustmentsModuleRelationId], item);
                Message.info('Adjustment item updated successfully');
            })
            .catch(function (e) {
                if (item.editingAmount) {
                    item.payment_amount = item.bkp;
                } else {
                    item.payment_percent = item.bkp;
                }
                self.PPIprocessPaymentFields(self.modulesLookup[adjustmentsModuleRelationId], item);
                Message.dberror(e);
            })
            .finally(function () {
                item.loading = false;
                self.modulesLookup[adjustmentsModuleRelationId].isBusy = false;
            })
    }

    ProgressPaymentSA.prototype.undoLastAction = function (t) {
        var self = this;
        CommonEntityInstance.commonUndoLastAction(t, 'PROGRESS_PAYMENT', self.contractId, self.moduleId).then(function () {
            self.get_general_info().then(function () {
                userService.isCurrentContractPeriodsChanged = true;
                self.get_activity_summary();
            });
        })
    }

    ProgressPaymentSA.prototype.getStartScreens = function () {
        var self = this;
        var p = $q.defer();
        self[URI.MODULE_GRID.START_SCREENS.method](URI.MODULE_GRID.START_SCREENS, { url: { workflowId: userService.getWorkflowId(self.moduleId), contractId: self.contractId }, urltype: 'obj'}, { headers: { moduleId: self.moduleId } })
            .then(function (r) {
                self.startScreens = r;
                p.resolve(r);
            })
            .catch(function (e) { console.error(e); p.reject(); });

        return p.promise;
    }

    ProgressPaymentSA.prototype.getOtherDraftUsers = function () {
        var self = this;

        if (self.generalInfo.otherDraftsUser && self.generalInfo.otherDraftsUser.length == 1)
            return self.generalInfo.otherDraftsUser[0];

        return self.generalInfo.otherDraftsUser.join(', ');
    }

    ProgressPaymentSA.prototype.viewOtherDrafts = function () {
        var self = this;

        if (!self.hasManageDrafts || !self.generalInfo.isDraftState)
            return;
        else {
            self.showPP = !self.showPP;
        }
    }

    ProgressPaymentSA.prototype.get_other_drafts = function () {
        var self = this;
        var p = $q.defer();
        var dataURL = URI.PROGRESS_PAYMENT.PP_OTHER_DRAFTS;
        var params = { paymentPeriodId: self.selectedPeriodId };
        self[dataURL.method](dataURL, { url: params, urltype: 'obj', body: {} })
            .then(function (r) {
                self.otherDrafts = r.map(element => {
                    const row = {
                        id: element.entityInstanceId,
                    };
                    self.otherDraftsColumns.forEach(column => {
                        if (column.name === 'state_name') {
                            row.state_name = {
                                bgColor: element.state_color,
                                color: element.state_text_color,
                                label: element.state_name
                            };
                        } else {
                            row[column.name] = element[column.name] ?? element[column.id];
                        }
                        });
                        return row;
                    });
                p.resolve();
            })
            .catch(function (e) {
                console.error(e);
                p.reject(e);
            });

        return p.promise;
    }

    ProgressPaymentSA.prototype.openPP = function (row) {
        var self = this;
        self.showPP = true;
        self.get_general_info(row.id);
    }

    ProgressPaymentSA.prototype.get_wbs = function (module, isReload) {
        var self = this;

        if (!isReload) {
            self.wbs = [];
            self.isBusy = true;
            self.wbsItemCount = 0;
            self.wbsItemTotal = 0;
        }

        const editMode = self.editMode || self.isAllPayments || self.generalInfo.isDraftState;
        self[URI.WBS.GET_BY_PP.method](`${URI.WBS.GET_BY_PP}?contractId=${self.contractId}&sovEntityInstanceId=${module.sovEntityInstanceId}&ppEntityInstanceId=${self.entityInstanceId}&editMode=${editMode}`)
            .then(function (wbs) {
                if (wbs.length) {
                    if (isReload) {
                        module["payment_amount"] = wbs[0].sovItemTotal;
                        self.copyTotalsRecursively(wbs, self.wbs);
                    } else {
                        self.wbs = wbs;
                        self.wbsItemCount = self.wbs.map(x => x.sovItemCount).length;
                        self.wbsItemTotal = self.wbs.map(x => x.sovItemTotal);
                    }
                }
            })
            .catch(function (err) {
                Message.dberror(err);
            })
            .finally(function () {
                self.isBusy = false;
                module.loading = false;
            });
    }

    ProgressPaymentSA.prototype.copyTotalsRecursively = function (listA, listB) {
        var self = this;
        
        if (!listA || !listB) return;

        for (var i = 0; i < listA.length; i++) {
            var itemA = listA[i];
            var itemB = listB[i]; // Match by index, not search

            if (itemB && itemA.id === itemB.id) {
                // Copy total
                itemB.sovItemTotal = itemA.sovItemTotal;

                // Recurse for children if both exist
                if (itemA.children && itemB.children) {
                    self.copyTotalsRecursively(itemA.children, itemB.children);
                }
            }
        }
    }

    ProgressPaymentSA.prototype.anyChangesOnModules = function () {
        var self = this;
        return (self.modulesList || []).some(module => self.anyChangesOnItems(module));
    }
    
    ProgressPaymentSA.prototype.anyChangesOnItems = function (module) {
        return (module.items || []).some(item => item.changed);
    }

    return ProgressPaymentSA;
});